import type { FC, ReactElement } from 'react';

import { ErrorBoundary } from '../../errorBoundary/ErrorBoundary';
import { Loader } from '../../loader/Loader';

import styles from './Chat.module.css';

export interface ChatProps {
  chatFooter: ReactElement;
  messagesWrapper: ReactElement;
  privateOptions?: ReactElement | null;
}

export const Chat: FC<ChatProps> = ({ privateOptions, messagesWrapper, chatFooter }): ReactElement => (
  <ErrorBoundary fallback={<Loader />}>
    <div data-testid="chat" className={styles.chat}>
      {privateOptions}
      {messagesWrapper}
      {chatFooter}
    </div>
  </ErrorBoundary>
);
